import styled from 'styled-components';
import { NO_TRANSLATE_CLASSNAME } from '../no-translate/translation.constants';

export const GaugueValueLabel = styled.div.attrs({
    className: NO_TRANSLATE_CLASSNAME,
})`
    margin-left: ${({ marginLeft }) => (marginLeft > 95 ? 95 : marginLeft)}%;
    font-weight: 500;
`;

export const GaugeBarWrapper = styled.div`
    align-self: center;
    width: 100%;
    position: relative; 
`;
